export default {
  required: "Required",
  max_length: "Maximum length is {{max}} characters",
  min_length: "Minimum length is {{min}} characters",
  email: "Invalid email format",
  number: "The {{field}} must be a number",
  integer: "The {{field}} must be an integer",
  min: "The {{field}} must be at least {{min}}",
};